import { __ } from '../i18n/vsme';

export type CompanyMissionStartCapability = {
  capabilities?: {
    startMission?: boolean;
  };
};

export const companyCanStartMission = (
  company: CompanyMissionStartCapability | null | undefined,
): boolean => company?.capabilities?.startMission === true;

export const missionStartPermissionDeniedMessage = (): string =>
  __('Vous n’avez pas la permission de démarrer une mission pour ce dossier.');
